<form class="k-form k-form-horizontal" style="width: 900px;">
  <kendo-grid #grid [data]="gridData" style="height: 600px; overflow-y: auto;" class="custom-row-height">

    <!-- nome -->
    <kendo-grid-column field="nomeArtigo" [title]="customMsgService.translate('name')" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.nomeArtigo }} </div>
      </ng-template>
    </kendo-grid-column>

    <!-- codigo interno -->
    <kendo-grid-column field="codigoInternoArtigo" [title]="customMsgService.translate('codigoInterno')" [width]="70">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name"> {{ dataItem.codigoInternoArtigo }} </div>
      </ng-template>
    </kendo-grid-column>

    <!-- permissao -->
    <kendo-grid-column [title]="customMsgService.translate('permissao')" [width]="30">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [checked]="dataItem.autorizado" (valueChange)="onSwitchChange(dataItem)"></kendo-switch>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div class="k-form-buttons">
    <button kendoButton [primary]="true" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>

<style>
  .custom-row-height .k-grid-content tr {
    height: 30px;
    /* Ajuste a altura conforme necessário */
  }
</style>